module.exports = __webpack_public_path__ + "static/media/NightIcon.aba507ea.png";